import React from 'react'
import moment from 'moment'
import Datetime from 'react-datetime'
import {Calendar} from 'jbc-front/components/icons'
import {InputWithIcon} from 'jbc-front/components/presenters/form/InputWithIcon'

type DateFieldProps = {
  // oxlint-disable-next-line typescript/no-explicit-any
  inputProps?: any
  value: moment.Moment | string
  onChange: (value: moment.Moment | string) => void
  small?: boolean
}

type DatetimepickerProps = {
  // oxlint-disable-next-line typescript/no-explicit-any
  renderInput?: (props: any, openCalendar: () => void) => JSX.Element
  value: string | moment.Moment
  onChange: (value: string | moment.Moment) => void
  timeFormat: boolean
}

export const DateField: React.FC<DateFieldProps> = ({inputProps, value, onChange, small = false}) => {
  // oxlint-disable-next-line typescript/no-explicit-any
  const renderInput = (props: any, openCalendar: () => void) => {
    return (
      <div>
        <InputWithIcon small={small} onIconClick={openCalendar} {...props}>
          <Calendar />
        </InputWithIcon>
      </div>
    )
  }

  const datetimeProps: DatetimepickerProps = {
    renderInput: renderInput,
    value: value,
    onChange: (value) => onChange(value),
    timeFormat: false,
  }

  return <Datetime {...datetimeProps} inputProps={{...inputProps}} />
}
